import React, { PureComponent } from 'react';
import { compose } from 'redux';
import { formatDataBidAsk } from '../../helpers/Common';
import { formatPrice, formatTextFloat } from '../../helpers/Text';

class BidAskInfo extends PureComponent {
  getFormatFunc = () => {
    return compose(
      formatTextFloat,
      formatPrice,
    );
  };

  getBidAskValue = (value, volume) => {
    const { priceInfo, bidAskInfo } = this.props;
    const data = this.getFormatFunc()(value);

    return (
      formatDataBidAsk(
        data,
        volume,
        bidAskInfo.tradingDate,
        false,
        priceInfo.marketStatus,
        priceInfo.comGroupCode,
      ) || data
    );
  };

  render() {
    const { priceInfo, bidAskInfo } = this.props;

    return (
      <div className="item-infor mr-3 ml-3">
        <div className="item-infor--first-row">
          <div className="item">
            <div className="main-text">O:</div>
            <div className="sub-text font-weight-bold">
              {this.getFormatFunc()(priceInfo.openPrice)}
            </div>
          </div>
          <div className="item">
            <div className="main-text">H:</div>
            <div className="sub-text font-weight-bold">
              {this.getFormatFunc()(priceInfo.highestPrice)}
            </div>
          </div>
          <div className="item">
            <div className="main-text">L:</div>
            <div className="sub-text font-weight-bold">
              {this.getFormatFunc()(priceInfo.lowestPrice)}
            </div>
          </div>
        </div>
        <div className="item-infor--second-row">
          <div className="item">
            <div className="main-text">BID:</div>
            <div className="sub-text font-weight-bold">
              {this.getBidAskValue(
                bidAskInfo.best1Bid,
                bidAskInfo.best1BidVolume,
              )}
            </div>
          </div>
          <div className="item">
            <div className="main-text">ASK:</div>
            <div className="sub-text font-weight-bold">
              {this.getBidAskValue(
                bidAskInfo.best1Offer,
                bidAskInfo.best1OfferVolume,
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default BidAskInfo;
